import { useIsPortrait, useIsSmallerThanWide } from '../../../styles/hooks/media';

export const useDrawerExpandable = (expandable: boolean): boolean => {
  const isSmallerThanWide = useIsSmallerThanWide();
  const isPortrait = useIsPortrait();
  return expandable && isSmallerThanWide && isPortrait;
};
